export default __webpack_public_path__ + "static/media/ui-rotation.15f8d328.svg";